import { AxiosInstance } from 'axios';

import { Authenticable, RoleResponse } from '../../Api/CRM/Responses/AdminResponse';
import { $ } from '../../base/bootstrap';
import { addTrailingSlashToUrl } from '../../components/common/Route';
import * as Constants from '../helpers/Constants';
import { PermissionList, PermissionType, RoleList, RoleType } from '../helpers/Permissions';

import Storage, { deleteCRMCredentials } from './Storage';

async function authenticate(username: string, password: string, captcha: string): Promise<Response> {
    return fetch(addTrailingSlashToUrl(`${Constants.URL}/login`), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        credentials: 'include',
        body: JSON.stringify({
            grant_type: 'password',
            username,
            password,
            'g-recaptcha-response': captcha,
        }),
    });
}

async function signOut(axiosCRM: AxiosInstance): Promise<void> {
    try {
        await axiosCRM.post('/crea/api/log_logout');
    } finally {
        deleteCRMCredentials();
    }

    window.location.href = addTrailingSlashToUrl(`${Constants.URL}/login`);
}

function isAuthenticated(): boolean {
    return !!Storage.load('access_token');
}

const startingWordsMatch = (name: string, search: string): boolean => new RegExp(`^${search}($| )`).test(name);

function roleHasPermission(role: RoleResponse, searchPermission: PermissionType): boolean {
    return role?.permissions.some((permission) => startingWordsMatch(permission.name, searchPermission));
}

function userCan(user: Authenticable, searchPermission: PermissionType): boolean {
    // TODO: change name to userHasPermission
    if (user?.permissions.some((permission) => startingWordsMatch(permission.name, searchPermission))) {
        return true;
    }

    return user?.roles.some((role) => roleHasPermission(role, searchPermission));
}

function userHasAnyPermission(user: Authenticable, permissions: PermissionList): boolean {
    return permissions?.some((permission) => userCan(user, permission));
}

function userHasRole(user: Authenticable, searchRole: RoleType): boolean {
    return user?.roles.some((role) => startingWordsMatch(role.name, searchRole));
}

function userHasAnyRole(user: Authenticable, roles: RoleList): boolean {
    return roles?.some((role) => userHasRole(user, role));
}

function userHasAnyRoleOrPermission(
    user: Authenticable,
    roles: RoleList = [],
    permissions: PermissionList = []
): boolean {
    if (!user) {
        return false;
    }

    if (userHasAnyRole(user, roles)) {
        return true;
    }

    return userHasAnyPermission(user, permissions);
}

export default {
    authenticate,
    signOut,
    isAuthenticated,
    userHasRole,
    userHasAnyRole,
    userCan,
    userHasAnyPermission,
    userHasAnyRoleOrPermission,
};
